import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangSelectComponent } from './lang-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSelectModule } from 'ng-zorro-antd/select';

@NgModule({
  declarations: [LangSelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzSelectModule,
    NzDropDownModule,
  ],
  exports: [LangSelectComponent],
})
export class LangSelectModule {}
